import { localCache } from "@overrides/utilities";
import { type CacheKey, cacheKey } from "./cache-key";

export const availabilityTokenCache = localCache<CacheKey>({
  prefix: "availability-token-cache",
  cacheKey,
  maxItems: 40,
});
